import styled from 'styled-components';

const Container = styled.div`
  background-color: var(--neutral-1);
  margin-top: 50px;
  margin-bottom: ${({ bottomSection }) => bottomSection && `60px`};
  padding: 25px 25px 10px;

  .webinar-key-takeaways--title {
    font-weight: 900;
    line-height: 120%;
    color: var(--normal-description-color);
  }

  li {
    margin: 15px 0;
  }

  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

export { Container };
